// Pair only after an explicit administrator submission. Never sends messages.
export function pairingQr(result, connection, validConnection) {
  if (
    !validConnection(result?.connection) ||
    result.connection.id !== connection.id
  )
    throw Error("INVALID_CONNECTION");
  if (!result.qr) return null;
  const value = result.qr;
  if (
    typeof value.image !== "string" ||
    value.image.length > 350000 ||
    !/^data:image\/png;base64,[A-Za-z0-9+/]+={0,2}$/.test(value.image) ||
    !Number.isFinite(Date.parse(value.displayUntil)) ||
    Date.parse(value.displayUntil) <= Date.now() ||
    Date.parse(value.displayUntil) > Date.now() + 15000
  )
    throw Error("INVALID_QR");
  return {
    image: value.image,
    displayUntil: value.displayUntil,
    label: connection.label,
  };
}

export async function pairConnection({
  connection,
  request,
  validConnection,
  current,
  update,
  wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms)),
}) {
  let row = connection;
  let qr = null;
  let renewals = 0;
  const started = Date.now();
  const check = (value) => {
    if (!validConnection(value) || value.id !== connection.id)
      throw Error("INVALID_CONNECTION");
    if (value.state === "NUMBER_MISMATCH") throw Error("NUMBER_MISMATCH");
    if (value.state === "UNAVAILABLE") throw Error("PROVIDER_UNAVAILABLE");
    return value;
  };
  const publish = (phase) => {
    if (current()) update({ row, qr, phase });
  };
  if (!current()) return;
  row = check(row);
  if (row.state === "CONNECTED") {
    publish("connected");
    return;
  }
  if (!row.actionsEnabled) {
    publish("blocked");
    return;
  }
  publish("creating");
  if (row.state === "NOT_CREATED") {
    row = check(
      await request({
        method: "POST",
        url: `/whatsapp/connections/${row.id}/create`,
      })
    );
    if (!current()) return;
  }
  if (row.state === "CONNECTED") {
    publish("connected");
    return;
  }
  if (!row.actionsEnabled) {
    publish("blocked");
    return;
  }
  if (!["DISCONNECTED", "CONNECTING"].includes(row.state))
    throw Error("CHECK_STATUS");
  while (current() && Date.now() - started < 120000) {
    if (!qr || Date.parse(qr.displayUntil) <= Date.now()) {
      if (renewals >= 8) break;
      qr = null;
      publish("generating");
      const result = await request({
        method: "POST",
        url: `/whatsapp/connections/${row.id}/qr`,
      });
      if (!current()) return;
      row = check(result?.connection);
      qr = pairingQr(result, row, validConnection);
      renewals += 1;
      if (row.state === "CONNECTED") {
        qr = null;
        publish("connected");
        return;
      }
      if (!qr) throw Error("QR_UNAVAILABLE");
      publish("scanning");
    }
    await wait(3000);
    if (!current()) return;
    row = check(
      await request({ method: "GET", url: `/whatsapp/connections/${row.id}` })
    );
    if (!current()) return;
    if (row.state === "CONNECTED") {
      qr = null;
      publish("connected");
      return;
    }
    if (!row.actionsEnabled) {
      qr = null;
      publish("blocked");
      return;
    }
    if (!["DISCONNECTED", "CONNECTING"].includes(row.state))
      throw Error("CHECK_STATUS");
  }
  qr = null;
  publish("paused");
}
